// extracted by mini-css-extract-plugin
export var centerText = "_58-8";
export var container = "_58-0";
export var doughnutContainer = "_58-7";
export var legend = "_58-a";
export var legendItemColorDisplay = "_58-b";
export var legendItemLabel = "_58-d";
export var legendItemValue = "_58-c";
export var lg = "_58-5";
export var maxWidth = "_58-9";
export var md = "_58-4";
export var responsive = "_58-6";
export var sm = "_58-3";
export var xs = "_58-2";
export var xxs = "_58-1";